import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    customerFissions: {
        url: `${customerApi}/api/customer_fissions`,
        type: 'GET',
    },
    fissionActivity: {
        url: `${customerApi}/api/fission/activity`,
        type: 'POST',
    },
    fissionInfo: {
        url: `${customerApi}/api/fission`,
        type: 'GET',
    },
    fissionStatByDate: {
        url: `${customerApi}/api/fission_stat/by_date`,
        type: 'GET',
    },
    fissionStatSummary: {
        url: `${customerApi}/api/fission_stat/summary`,
        type: 'GET',
    },
    fissionStatData: {
        url: `${customerApi}/api/fission_stat/by_date.xlsx`,
        type: 'GET',
    },
    fissionChannel: {
        url: `${customerApi}/api/fission/channel`,
        type: 'POST',
    },
    fissionWelcomeMessage: {
        url: `${customerApi}/api/fission/welcome_message`,
        type: 'POST',
    },
}
